var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"marketing-tabs"},[_c('tabs',{attrs:{"items":_vm.tabs,"active-tab":_vm.$route.fullPath},on:{"click":_vm.activateTab}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }